import { baseFetch } from "./base";
import { User } from "../types";

export const sendLoginCode = async (username: string): Promise<string> => {
  try {
    // legacy endpoint:
    // const response = await baseFetch.post("/send_email_code", {
    const response = await baseFetch.post(
      "/auth/send_login_code",
      {
        username,
      },
      {
        headers: {
          "No-Auth": true,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error sending login code:", error);
    throw error;
  }
};

export const loginWithOneTimeCode = async (
  username: string,
  code: number
): Promise<{
  valid: boolean;
  message?: string;
  token?: string;
  user?: User;
}> => {
  try {
    const response = await baseFetch.post(
      "/auth/login_with_code",
      {
        username,
        code,
      },
      {
        headers: {
          "No-Auth": true,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error logging in with one-time code:", error);
    throw error;
  }
};

export const changePassword = async (
  login: string,
  newPassword: string,
  code: number
): Promise<string> => {
  try {
    const response = await baseFetch.post(
      "/change_password",
      {
        login,
        new_password: newPassword,
        code,
      },
      {
        headers: {
          "No-Auth": true,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};
